/**
 * ai_mall_py 通道 HTTP 封装（118 方案 P4：直播观看域由 Java 老后端迁移到 py）。
 *
 * 说明：
 * - baseURL = AI_BASE_URL + /api（D17 动态推导：相对路径 /ai-api——dev 走 vite
 *   代理、生产走 nginx 别名，均剥别名转发 py 后端，后端收到 /api/xxx）
 * - 响应为 GlxVo 信封 {success, error, data}，glxGet/glxPut/glxPost 统一解包
 *   取 data 返回（参照 ai_mobile src/http/ai-http.ts 的响应处理与错误处理）
 * - 错误处理：HTTP 非 2xx 仅 console.error 后 reject（观看端为匿名接口，
 *   无 426 登录跳转需求），信封内 error.msg 由后端以 4xx 状态码返回，同样走这里
 */
import Axios from "axios";
import { AI_BASE_URL } from "./api-util";

const aiHttp = Axios.create({
    baseURL: `${AI_BASE_URL}/api`,
    withCredentials: true,
    timeout: 1000 * 60 * 2,
    headers: {
        "Content-Type": "application/json"
    }
});

aiHttp.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status;
        // 信封错误信息（GlxVoError.msg）优先，便于排查
        const errMsg = error?.response?.data?.error?.msg;
        console.error(`[aiApiUtil] fail ${status ?? "NET"} ${error?.config?.method?.toUpperCase() ?? "?"} ${error?.config?.url ?? "?"}${errMsg ? ` ${errMsg}` : ""}`);
        return Promise.reject(error);
    }
);

/** GET：解 GlxVo 信封取 data */
export async function glxGet(url, config) {
    const response = await aiHttp.get(url, config);
    return response.data?.data;
}

/** PUT：解 GlxVo 信封取 data（config: {data, params}） */
export async function glxPut(url, config) {
    const response = await aiHttp.put(url, config?.data, { params: config?.params });
    return response.data?.data;
}

/** POST：解 GlxVo 信封取 data（config: {data, params}） */
export async function glxPost(url, config) {
    const response = await aiHttp.post(url, config?.data, { params: config?.params });
    return response.data?.data;
}
